import React from 'react'

import { Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import FolderSelect from '../../../../containers/folders/select/FolderSelect'
import IconText from '../../../../packages/kiti/components/presentation/IconText'
import Input from '../../../../packages/kiti/components/form/Input'
import Text from '../../../../packages/kiti/components/presentation/Text'

const FolderAndNameBar = () => {
  const form = useForm()
  const [isEditingFolder, setIsEditingFolder] = React.useState(false)
  const [isEditingName, setIsEditingName] = React.useState(false)
  const { handleChange } = useFormState()

  return (
    <Grid gap={0.4} align="center">
      {isEditingFolder ? (
        <FolderSelect
          value={form.folder}
          onBlur={() => setTimeout(() => setIsEditingFolder(false), 200)}
          onChange={value => {
            handleChange('folder', value)
            setIsEditingFolder(false)
          }}
          autoFocus
        />
      ) : (
        <IconText
          iconRight="BsCaretDownFill"
          color={form?.folder?.name ? 'dark2' : 'dark5'}
          bold={form?.folder}
          label={form?.folder?.name || 'Sem pasta'}
          size="xsmall"
          iconSize={0.6}
          gap={0.3}
          onClick={e => {
            setIsEditingFolder(true)
            e.stopPropagation()
          }}
        />
      )}

      <Text size="xsmall"> / </Text>

      {isEditingName ? (
        <Input
          value={form.name}
          onBlur={() => setTimeout(() => setIsEditingName(false), 200)}
          onChange={handleChange('name')}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              e.preventDefault()
              setIsEditingName(false)
            }
          }}
          autoFocus
        />
      ) : (
        <IconText
          iconRight="BsFillPencilFill"
          color={form?.name ? 'dark2' : 'dark5'}
          bold={form?.name}
          label={form?.name || 'Sem nome'}
          size="xsmall"
          iconSize={0.6}
          gap={0.3}
          onClick={e => {
            setIsEditingName(true)
            e.stopPropagation()
          }}
        />
      )}
    </Grid>
  )
}

export default FolderAndNameBar
